// extracted by mini-css-extract-plugin
export default {"root":"UIqEnuMARzsZg7WDcsRz","tag":"yoSa6yvq1BkEN33D5fCD","hidden-popper":"lyWpmPwlDS_NKjPC1E8C","hiddenPopper":"lyWpmPwlDS_NKjPC1E8C"};